import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { all } from 'q';
import {p} from "@angular/core/src/render3";

@Component({
  selector: 'lc-indexeddbpage',
  templateUrl: './indexeddbpage.component.html',
  styleUrls: ['./indexeddbpage.component.scss']
})
export class IndexeddbpageComponent implements OnInit {

  orders = [];
  client_by_id = {};
  stored_orders = []; // raw version as stored in indexedDB
  loading = false;
  backup_success = false;
  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.get_local_orders();
  }

  backup_all_pending(){
    this.loading = true;
    let pending = [];
    for( let order of this.stored_orders ){
      if( order.status !== 'NEW' ) {
        pending.push(order);
      }
    }
    if(pending.length == 0) {
      pending = this.stored_orders;
    }
    this.dataService.send_backup(pending).subscribe(res =>{
      this.backup_success = true;
      this.loading = false;
    }, err => {
      this.loading = false;
    })
  }

  get_local_orders() {
    this.dataService.local_db.orders.reverse().toArray().then(
      (all_orders) => {
        this.stored_orders = all_orders;
        for (const order of this.stored_orders) {
          const cl_code = order.headers['x-auth'][0];
          if(!!cl_code && !this.client_by_id[cl_code]){
            this.client_by_id[cl_code] = {company: '--------'};
            this.dataService.getUserForCode(cl_code).subscribe(user => {
              this.client_by_id[cl_code] =  user;
            })
          }
        }

        // console.log(this.orders);
      })
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/indexeddbpage/indexeddbpage.component.ts